export const PERFORMANCE_TIME_FRAME = "PERFORMANCE_TIME_FRAME";

const storeName = "performanceTimeFrame";

const reducer = (state = "thisWeek", action) => {
    switch (action.type) {
        case PERFORMANCE_TIME_FRAME:
            return action.payload;
        default:
            return state;
    }
};

const performanceTimeFrameReducerMapping = { [storeName]: reducer };
export default performanceTimeFrameReducerMapping;
